import { Translator } from 'Translator';
import Modal from 'components/Modal';
import ModalBody from 'components/Modal/ModalBody';
import ModalFooter from 'components/Modal/ModalFooter';
import RoundedButton from 'components/RoundedButton';
import Strong from 'components/Strong';
import CheckmarkIcon from 'components/icons/CheckmarkIcon';
import React from 'react';

const CSS = require('./USPModal.less');

function USPModal({ show, onClose }) {
  return (
    <Modal className={CSS.Modal} show={show} onClose={onClose}>
      <ModalBody className={CSS.Body}>
        <h2 className={CSS.Title}>
          {Translator.i18n(
            'SearchPage.SmallUSPBanner.title',
            'Explore Comfortably',
          )}
        </h2>
        <p className={CSS.Text}>
          {Translator.i18n(
            'SearchPage.SmallUSPBanner.text',
            'The safest city tours with local experts',
          )}
        </p>
        <ul>
          <li className={CSS.ListItem}>
            <div>
              <CheckmarkIcon className={CSS.CheckMark} />
            </div>
            <div>
              <Strong className={CSS.USPTitle}>
                {Translator.i18n(
                  'SearchPage.USPModal.title1',
                  'Only private tours',
                )}
              </Strong>
              <span className={CSS.USPText}>
                {Translator.i18n(
                  'SearchPage.USPModal.text4',
                  'No strangers, just you and your local host. Fully customize your trip to your needs.',
                )}
              </span>
            </div>
          </li>
          <li className={CSS.ListItem}>
            <div>
              <CheckmarkIcon className={CSS.CheckMark} />
            </div>
            <div>
              <Strong className={CSS.USPTitle}>
                {Translator.i18n(
                  'SearchPage.USPModal.title2',
                  'With local experts',
                )}
              </Strong>
              <span className={CSS.USPText}>
                {Translator.i18n(
                  'SearchPage.USPModal.text5',
                  'From historical facts to the most up-to-date health regulations.',
                )}
              </span>
            </div>
          </li>
          <li className={CSS.ListItem}>
            <div>
              <CheckmarkIcon className={CSS.CheckMark} />
            </div>
            <div>
              <Strong className={CSS.USPTitle}>
                {Translator.i18n(
                  'SearchPage.USPModal.title3',
                  'Without the crowds',
                )}
              </Strong>
              <span className={CSS.USPText}>
                {Translator.i18n(
                  'SearchPage.USPModal.text6',
                  'Experiences designed to take you away from the crowds towards authentic local spots.',
                )}
              </span>
            </div>
          </li>
        </ul>
      </ModalBody>
      <ModalFooter className={CSS.ButtonContainer}>
        <RoundedButton className={CSS.OkButton} onClick={onClose} fullWidth>
          {Translator.i18n('SearchPage.USPModal.button', 'Ok, got it!')}
        </RoundedButton>
      </ModalFooter>
    </Modal>
  );
}

export default USPModal;
